/**
 * JSM DIGITAL SOLUTIONS — PrintQ Device Fingerprint Helper
 *
 * Retrieves stable hardware fingerprint via Electron IPC (native Windows)
 * or falls back to stable browser localStorage fingerprint if accessed on web.
 */

export async function getDeviceFingerprint() {
  if (window.jsmDesktop?.device?.getFingerprint) {
    try {
      const info = await window.jsmDesktop.device.getFingerprint();
      if (info && info.fingerprint_hash) {
        return info;
      }
    } catch (e) {
      console.warn("Electron device fingerprint error:", e);
    }
  }

  // Browser / web fallback:
  let browserId = localStorage.getItem("printq_device_id");
  if (!browserId) {
    browserId = "web-" + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem("printq_device_id", browserId);
  }

  return {
    fingerprint_hash: browserId,
    machine_name: navigator.userAgent.includes("Windows") ? "Windows Web Device" : "Web Client",
    os_name: navigator.platform || "Web",
    app_version: "1.0.0",
  };
}
